import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  styled,
  IconButton,
  TextField,
  Radio,
  FormControlLabel,
  RadioGroup,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import { api, put, post, get } from "../../../../utils/api";
import { companyId } from "../../../../utils/companyId";
import InputField from "../../../../Components/Masters/InputField";
import SelectField from "../../../../Components/Masters/SelectField";
import contries from "../../../Masters/Roles and Permissions/Country.json";
import { validateNumber } from "../../../../utils/validateFields";
import PhoneField from "../../../../Components/Masters/PhoneField";
import EmailField from "../../../../Components/Masters/EmailField";
import LocationAutocomplete from "../../../../Components/Common/LocationAutocomplete";
import EditDialog from "../../../../Components/Common/EditDialog";
import GoogleMapsAutocomplete from "../../../../Components/Common/GoogleMapsAutocomplete";

function AddPartner({
  inputData,
  fetchData,
  id,
  element,
  data,
  setAddData,
  addData,
  setsnackOpen,
  addUrl,
  updateUrl,
  direction,
}) {
  const [errors, setErrors] = useState({});
  const initialState = {
    partnerCompany: element?.partnerCompany?._id || "",
    newPartnerName: element?.newPartnerName || "",
    partner: element?.partner || "",
    country: element?.country || "",
    // partnershipType: element?.partnershipType || "",
    industry: element?.industry || "",
    materialsOrServices: element?.materialsOrServices || "",
    address: element?.address || "",
    contactPersonName: element?.contactPersonName || "",
    contactNumber: {
      countryCode: element?.contactNumber?.countryCode || "",
      mobileNo: element?.contactNumber?.mobileNo || "",
    },
    email: element?.email || "",
  };

  const [formData, setFormData] = useState(initialState);
  const [formData2, setFormData2] = useState(initialState);
  const [verifybtn, setverifybtn] = useState({ email: false, phone: false });
  const [verify, setVerify] = useState({
    phone: false,
    email: false,
    emailMsg: "",
    phoneMsg: "",
  });
  const [TaskAltIcons, setTaskAltIcons] = useState({
    email: false,
    phone: false,
  });
  const [radioType, setRadioType] = useState("existing");
  const [editDialog, setEditDialog] = useState(false);

  // const partnershipTypeval = ["Supplier", "Customer"];

  const industryTypes = [
    "Apparel, Accessories & Footwear",
    "Appliance Manufacturing",
    "Building Products & Furnishings",
    "E-Commerce",
    "Household & Personal Products",
    "Toys & Sporting Goods",
    "Multiline and Specialty Retailers & Distributors",
    "Construction Materials",
    "Coal Operations",
    "Oil & Gas - Exploration & Production",
    "Iron & Steel Producers",
    "Oil & Gas - Midstream",
    "Metals & Mining",
    "Oil & Gas - Refining & Marketing",
    "Oil & Gas - Services",
    "Insurance",
    "Asset Management & Custody Activities",
    "Commercial Banks",
    "Consumer Finance",
    "Security & Commodity Exchanges",
    "Investment Banking & Brokerage",
    "Mortgage Financing",
    "Alcoholic Beverages",
    "Agricultural Products",
    "Food Retailers & Distributors",
    "Meat, Poultry & Dairy",
    "Non-Alcoholic Beverages",
    "Processed Foods",
    "Restaurants",
    "Tobacco",
    "Biotechnology & Pharmaceuticals",
    "Healthcare Distributors",
    "Drug Retailers",
    "Health Care Delivery",
    "Managed Care",
    "Medical Equipment & Supplies",
    "Real Estate",
    "Engineering & Construction Services",
    "Electric Utilities & Power Generators",
    "Gas Utilities & Distributors",
    "Home Builders",
    "Waste Management",
    "Water Utilities & Services",
    "Biofuels",
    "Fuel Cells & Industrial Batteries",
    "Forestry Management",
    "Pulp & Paper Products",
    "Solar Technology & Project Developers",
    "Wind Technology & Project Developers",
    "Chemicals",
    "Aerospace & Défense",
    "Containers & Packaging",
    "Electrical & Electronic Equipment",
    "Industrial Machinery & Goods",
    "Advertising & Marketing",
    "Casinos & Gaming",
    "Education",
    "Hotels & Lodging",
    "Leisure Facilities",
    "Media & Entertainment",
    "Professional & Commercial Services",
    "Electronic Manufacturing Services & Original Design Manufacturing",
    "Hardware",
    "Internet Media & Services",
    "Semiconductors",
    "Software & IT Services",
    "Telecommunication Services",
    "Air Freight & Logistics",
    "Auto Parts",
    "Automobiles",
    "Cruise Lines",
    "Car Rental & Leasing",
    "Marine Transportation",
    "Rail Transportation",
    "Road Transportation",
  ];

  useEffect(() => {
    if (element?.partner) {
      setRadioType(element.partner);
    }
  }, [element]);

  useEffect(() => {
    setFormData(initialState);
    if (id && element) {
      setTaskAltIcons({ ...TaskAltIcons, phone: true, email: true });
    } else if (!id && !element) {
      setTaskAltIcons({ ...TaskAltIcons, phone: false, email: false });
    }
  }, [element, id]); // Ensure this runs when data changes

  useEffect(() => {
    if (element !== null) {
      setFormData(initialState);
      setFormData2(initialState);
    } else {
      setFormData(initialState);
      setFormData2(initialState);
    }
  }, [element]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setErrors((prevState) => ({
      ...prevState,
      [name]: "",
    }));

    // if (value?.length > 10) return;
    if (name === "contactNumber") {
      if (value?.length > 10) return;

      setFormData((prevState) => ({
        ...prevState,
        [name]: { ...prevState[name], mobileNo: value },
      }));
    } else
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
  };

  const handleCountryChange = (event) => {
    const selectedCountryCode = event.target.value;
    setErrors({ ...errors, country: "" });

    const selectedCountry = contries.countries.find(
      (country) => country.name === selectedCountryCode
    );

    if (selectedCountry) {
      setTaskAltIcons({ ...TaskAltIcons, phone: false });
      setFormData((prevData) => ({
        ...prevData,
        country: selectedCountry.name,
        contactNumber: {
          ...prevData.contactNumber,
          countryCode: selectedCountry.dial_code,
          mobileNo: "",
        },
      }));
    } else {
      console.error("Country not found in data");
    }
  };

  const handleExitAgree = () => {
    setEditDialog(false);
    setAddData(false);
    setErrors({});
    setverifybtn({ phone: false, email: false });
    setVerify({ phone: false, email: false });
    setFormData(initialState);
    if (data && id) setTaskAltIcons({ phone: true, email: true });
    //     setverifybtn({phone:false,email:false})
    if (!data && !id) {
      setTaskAltIcons({ phone: false, email: false });
    }
  };

  const handleClose = () => {
    // setAddData(false);
    // setErrors({});
    // resetFrom();
    const isFormDataUnchanged = Object.keys(formData).every((key) => {
      const value1 = formData[key];
      const value2 = formData2[key];
      if (
        typeof value1 === "object" &&
        value1 !== null &&
        typeof value2 === "object" &&
        value2 !== null
      ) {
        // For nested objects, do a deep comparison
        return JSON.stringify(value1) === JSON.stringify(value2);
      }

      // For primitive values or arrays, use strict equality
      return value1 === value2;
    });

    if (isFormDataUnchanged) {
      handleExitAgree();
    } else {
      // setAddData(false);
      // setErrors({});
      setEditDialog(true);
      // resetForm();
      // Show the EditDialog if there are changes
    }
  };

  const handlePartnerTypeChange = (event) => {
    const { value } = event.target;
    setRadioType(value);

    // setFormData((prevState) => ({
    //   ...prevState,
    //   partner: value,
    // }));
    setFormData(initialState);
    setErrors({});
  };

  const handleIndustryChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    setErrors((prevState) => ({
      ...prevState,
      [name]: "",
    }));
  };

  const handleCompanySelect = async (event) => {
    const selectedCompanyId = event.target.value;

    if (selectedCompanyId) {
      try {
        const response = await get(`/auth/getAllCompanies`);
        const selectedCompany = response.data.companies.find(
          (company) => company._id === selectedCompanyId
        );

        if (selectedCompany) {
          // Find the country object in the `contries.countries` array that matches the `countryCode`
          // const selectedCountry = contries.countries.find(
          //   (country) =>
          //     country.dial_code === selectedCompany.companyAdmin.countryCode
          // );
          const newCountryCode =
            selectedCompany?.companyAdmin?.countryCode?.split(" - ")[0];
          setFormData((prevState) => ({
            ...prevState,
            partnerCompany: selectedCompany?._id,
            industry: selectedCompany?.industry,
            address: selectedCompany?.companyAddress,
            contactPersonName: selectedCompany?.companyAdmin?.name,
            contactNumber: {
              ...prevState.contactNumber,
              countryCode: newCountryCode,
              mobileNo: selectedCompany?.companyAdmin?.phone,
            },
            email: selectedCompany?.companyAdmin?.email,
            country: selectedCompany ? selectedCompany?.country : "",
          }));
          setErrors((prevErrors) => ({
            ...prevErrors,
            partnerCompany: null,
          }));
        }
      } catch (error) {
        console.error("Error fetching company details:", error);
      }
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!radioType) {
      newErrors.partner = "Please select a partner type (Existing or New)";
    }

    // Conditional validation based on radioType
    if (radioType === "existing") {
      if (!formData.partnerCompany) {
        newErrors.partnerCompany = "Partner Name is required";
      }
      // if (!formData.partnershipType) {
      //   newErrors.partnershipType = "Partnership Type is required";
      // }
      if (!formData.materialsOrServices) {
        newErrors.materialsOrServices = "Materials / Services is required";
      }
    } else if (radioType === "new") {
      // Validate all fields if the type is 'new'
      inputData.forEach((input) => {
        const value = formData[input.fieldName];

        if (input.fieldName === "contactNumber") {
          const mobileNo = formData?.contactNumber.mobileNo;
          if (!mobileNo)
            newErrors[input.fieldName] = `${input.title} is required`;
          else if (formData.contactNumber.countryCode === "")
            newErrors[input.fieldName] = "Please Select Country";
          else if (!validateNumber(mobileNo) || mobileNo.length !== 10)
            newErrors[input.fieldName] = "Please enter 10 digit Mobile Number";
        } else if (
          radioType === "new" &&
          formData.newPartnerName === "" &&
          (input?.fieldName === "newPartnerName" ||
            input?.fieldName === "partner")
        ) {
          newErrors.newPartnerName = "New Partner Name is required";
        } else if ((!value || value === "") && input?.fieldName !== "partner") {
          newErrors[input.fieldName] = `${input.title} is required`;
        } else if (input.fieldName === "email") {
          const emailPattern =
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

          if (formData?.email === "")
            newErrors[input.fieldName] = `${input.title} is required`;
          else if (!emailPattern.test(value))
            newErrors[input.fieldName] = `Invalid ${input.title}`;
        }
      });
    }

    setErrors({ ...errors, ...newErrors });
    return Object.keys(newErrors).length === 0;
  };

  const handleLocationChange = (fieldName, value) => {
    console.log(fieldName, value, "first__");
    setFormData((prevState) => ({
      ...prevState,
      [fieldName]: value?.formatted_address,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: value ? "" : prevErrors[fieldName],
    }));
  };

  const Save = async () => {
    if (!validateForm()) return;

    const hardcodedData = {
      direction,
    };

    const payload = {
      ...formData,
      partner: radioType,
      ...hardcodedData,
    };

    if (!payload.partnerCompany) {
      console.log("Partner Name is missing!");
    }

    Object.keys(payload).forEach((key) => {
      if (
        payload[key] === "" ||
        (typeof payload[key] === "object" &&
          Object.keys(payload[key]).length === 0)
      ) {
        delete payload[key];
      }
    });

    const url = element?._id ? `${updateUrl}?Id=${element?._id}` : `${addUrl}`;

    const method = element?._id ? put : post;
    try {
      const res = await method(url, payload);
      console.log(res?.data, "resssssssssssss");
      if (res?.data) {
        setsnackOpen({
          open: true,
          message: res?.data?.message,
          severity: "success",
        });
        fetchData();
        // handleClose();
        handleExitAgree();
      }
    } catch (error) {
      if (error?.response) {
        const errorData = error?.response?.data;

        if (Array.isArray(errorData?.commonKeyMsg)) {
          setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            errorData.commonKeyMsg.forEach(({ key, msg }) => {
              newErrors[key] = msg;
            });
            return newErrors;
          });
        } else if (errorData?.errorKey && errorData?.message) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            [errorData.errorKey]: errorData.message,
          }));
        } else {
          setsnackOpen({
            open: true,
            message: errorData?.message,
            severity: "error",
          });
        }
        // setErrors({ api: error.response.data.message }); // Store error message
        // setsnackOpen({
        //   open: true,
        //   message: error.response.data.message, // Show message from backend
        //   severity: "error",
        // });
      } else {
        setsnackOpen({
          open: true,
          message: "Value Chain Partner already Added",
          severity: "error",
        });
      }
    }
  };

  const renderInputField = (el) => {
    const isExistingPartner = radioType === "existing";

    if (el.fieldName === "partner") {
      return (
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
            Value Chain Partner Name
          </Typography>
          <RadioGroup row value={radioType} onChange={handlePartnerTypeChange}>
            <FormControlLabel
              value="existing"
              control={<Radio />}
              label="Existing"
            />
            <FormControlLabel value="new" control={<Radio />} label="New" />
          </RadioGroup>

          {/* Conditionally render either the SelectField or InputField */}
          {radioType === "existing" && (
            <SelectField
              name="partnerCompany"
              value={formData.partnerCompany}
              // handleChange={handleIndustryChange}
              handleChange={handleCompanySelect}
              url={`${api}/auth/getAllCompanies`}
              errors={errors.partnerCompany}
            />
          )}

          {radioType === "new" && (
            <InputField
              handleChange={handleChange}
              placeholder="Enter Partner Name"
              value={formData.newPartnerName || ""}
              errors={errors.newPartnerName}
              fieldName="newPartnerName"
            />
          )}
        </Box>
      );
    }

    if (el.fieldName === "contactNumber")
      return (
        <Box>
          <PhoneField
            value={formData?.contactNumber?.mobileNo || ""}
            errors={errors[el.fieldName]}
            fieldName={el.fieldName}
            placeholder={el.placeholder}
            title={el.title}
            handleChange={handleChange}
            // showIcon={TaskAltIcons.phone === true}
            disable={isExistingPartner}
            {...{
              setTaskAltIcons,
              TaskAltIcons,
              setErrors,
              setFormData,
              element,
              formData,
              setVerify,
              verify,
              setverifybtn,
              verifybtn,
            }}
            countryCode={formData?.contactNumber?.countryCode || ""}
          />
        </Box>
      );

    if (el.fieldName === "email")
      return (
        <Box>
          <InputField
            title={el.title}
            placeholder={el.placeholder}
            handleChange={handleChange}
            value={formData?.email || ""}
            errors={errors[el.fieldName]}
            fieldName={el.fieldName}
            disabled={isExistingPartner}
            {...{
              setErrors,
              setFormData,
              element,
              formData,
              setVerify,
              verify,
              setverifybtn,
              verifybtn,
            }}
          />
        </Box>
      );

    if (el.fieldName === "industry")
      return (
        <SelectField
          title={el.title}
          name={el.fieldName}
          value={formData[el.fieldName]}
          handleChange={handleIndustryChange}
          options={industryTypes.sort()}
          errors={errors[el.fieldName]}
          disable={isExistingPartner}
        />
      );

    // if (el.fieldName === "partnershipType")
    //   return (
    //     <SelectField
    //       title={el.title}
    //       name={el.fieldName}
    //       value={formData[el.fieldName]}
    //       handleChange={handlePartnershipTypeChange}
    //       options={partnershipTypeval}
    //       errors={errors[el.fieldName]}
    //     />
    //   );

    if (el.fieldName === "address") {
      return (
        // <LocationAutocomplete
        //   title={"Address"}
        //   queryType="city"
        //   error={errors.address}
        //   value={formData.address || ""}
        //   onChange={(newValue) => handleLocationChange("address", newValue)}
        //   placeholder="Enter Address"
        //   disable={isExistingPartner}
        // />
        <GoogleMapsAutocomplete
          title={"Address"}
          placeholder="Enter Address"
          onPlaceSelect={(newValue) => {
            console.log("newValuewww", newValue);
            handleLocationChange("address", newValue);
          }}
          error={errors.address}
          // type={["geocode"]}
           type={[]}
          value={formData.address || ""}
          disable={isExistingPartner}
        />
      );
    }

    if (el.type === "select")
      return (
        <SelectField
          title={el.title}
          name={el.fieldName}
          value={formData[el.fieldName]}
          handleChange={handleCountryChange}
          options={contries.countries}
          errors={errors[el.fieldName]}
          disable={isExistingPartner}
        />
      );

    return (
      <InputField
        title={el.title}
        handleChange={handleChange}
        placeholder={el.placeholder}
        value={formData[el.fieldName] || ""}
        errors={errors[el.fieldName]}
        fieldName={el.fieldName}
        disabled={isExistingPartner && el.fieldName === "contactPersonName"}
      />
    );
  };

  const list = () => (
    <Box display="flex" gap={3} sx={{ width: "26rem" }}>
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={handleClose} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box sx={{ width: "90%", p: 3, backgroundColor: "#fff" }}>
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
        >
          {id ? "Edit Value Chain Partner" : "Add New Value Chain Partner"}
        </Typography>
        {inputData.map((el) => (
          <div key={el.fieldName}>{renderInputField(el)}</div>
        ))}
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={Save}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Drawer
      sx={{
        backgroundColor: "transparent",
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
          height: "100vh",
          minHeight: "100vh",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
      anchor="right"
      open={addData}
      onClose={handleClose}
    >
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
      {list()}
    </Drawer>
  );
}

export default AddPartner;
